import PropTypes from 'prop-types';
import Title from '../../../common/title';
import Subtitle from '../../../common/subtitle';
import { shouldShowRegion } from '../../../utils/shouldShowRegion';

const Heading = ({
  titlePrefix,
  destinationName,
  geographical,
  hideSubtitle,
  titleClassName,
  subTitleClassName,
}) => {
  return (
    <div className={`${!titleClassName ? 'gw-information-heading' : ''}`}>
      <Title titlePrefix={titlePrefix} className={titleClassName}>{destinationName}</Title>
      { !hideSubtitle && (
        <Subtitle
          geographical={geographical}
          shouldShowRegion={shouldShowRegion(geographical.region.id)}
          className={subTitleClassName}
        />
      )}
    </div>
  );
};

Heading.propTypes = {
  titlePrefix: PropTypes.string.isRequired,
  destinationName: PropTypes.string.isRequired,
  geographical: PropTypes.shape({
    country: PropTypes.shape({}),
    area: PropTypes.shape({}),
    region: PropTypes.shape({
      id: PropTypes.number,
    }),
  }).isRequired,
  hideSubtitle: PropTypes.bool,
  titleClassName: PropTypes.string,
  subTitleClassName: PropTypes.string,
};

Heading.defaultProps = {
  hideSubtitle: false,
  titleClassName: '',
  subTitleClassName: '',
};

export default Heading;
